import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';
import { useContext } from 'react';
import { AuthCtx }    from '../context/AuthContext';

export default function ResetPasswordPage() {
  const [params]   = useSearchParams();
  const navigate   = useNavigate();
  const token      = params.get('token') || '';
  const [pass, setPass]   = useState('');
  const [pass2, setPass2] = useState('');
  const [msg , setMsg ]   = useState('');
  const [loading, setLoading] = useState(false); // Añade este estado
  const { setToken } = useContext(AuthCtx);   //  <-  añade esto

  if (!token) {
    return (
      <Box mt={8} display="flex" justifyContent="center">
        <Paper sx={{ p:4, width: 380 }}>
          <Typography color="error">
            Enlace inválido o expirado
          </Typography>
          <Button onClick={() => navigate('/')} sx={{ mt:2 }}>
            Volver al inicio
          </Button>
        </Paper>
      </Box>
    );
  }

  const submit = async e => {
    e.preventDefault();
    if (loading) return;
    if (!token) return setMsg('Enlace inválido');
    if (pass !== pass2) return setMsg('Las contraseñas no coinciden');
    
    setLoading(true);
    setMsg('Procesando...');

    try {
        const response = await api.post('/clientes/reset', { token, nueva: pass });
        
        setMsg('✔ Contraseña actualizada correctamente');
        await new Promise(resolve => setTimeout(resolve, 1500));
    
        // Limpiar todos los tokens y redirigir a la página principal
        localStorage.removeItem('clientToken');
        localStorage.removeItem('adminToken');
        sessionStorage.clear();
        setToken(null);   
        navigate('/?reset=ok', { replace: true });
        
      } catch (err) {
        setMsg(err.response?.data?.message || 'Error al cambiar contraseña');
      } finally {
        setLoading(false);
      }
    };

  
  return (
    <Box mt={8} display="flex" justifyContent="center">
      <Paper sx={{ p:4, width: 380 }}>
        <Typography variant="h5" gutterBottom>
          Restablecer contraseña
        </Typography>

        <form onSubmit={submit}>
          <TextField
            fullWidth margin="normal" type="password"
            label="Nueva contraseña" value={pass}
            onChange={e=>setPass(e.target.value)} required
          />
          <TextField
            fullWidth margin="normal" type="password"
            label="Repetir contraseña" value={pass2}
            onChange={e=>setPass2(e.target.value)} required
          />

<Button
  fullWidth
  variant="contained"
  sx={{ mt: 2 }}
  type="submit"
  disabled={loading}
>
  {loading ? 'Procesando...' : 'Cambiar'}
</Button>
        </form>

        {msg && <Typography sx={{ mt:2 }}>{msg}</Typography>}
      </Paper>
    </Box>
  );
}
